/**
 * Created by Kevin Dench on 8/3/2016.
 */

/* @ngInject */
export default function MessageController($scope) {
    $scope.messageText = '';
    $scope.hasAlert = false;
    $scope.alertLevel = '';

    $scope.shouldAlert = function (boolean) {
        $scope.hasAlert = boolean;
    };

    $scope.getMessage = function (event, messageObject) {
        $scope.messageText = messageObject.message;
    };
}
